module.exports = __webpack_public_path__ + "img/logo-02.01ae8ec9.png";